import store from 'store';
import { lsGetOfferGuid } from 'helpers/store';

export default {
  checkStep(to, from, next) {
    if (
      store.getters['offer/getOfferField'] &&
      store.getters['offer/getOfferField']('currentStep') === to.meta.step
    ) {
      next();
    } else {
      const guid = lsGetOfferGuid();
      // Cuando el cliente hace un reload en el browser
      if (to.name && !from.name && guid) {
        next(`${guid}`);
      } else {
        next(from.path);
      }
    }
  }
};
